import { apiSlice } from '../../../store/api/apiSlice';

export interface InternalAppSummary {
  id: string;
  name: string;
  description?: string | null;
  client_id: string;
  allowed_audiences: string[];
  allowed_scopes: string[];
  rate_limit_per_minute: number;
  rate_limit_per_hour: number;
  ip_allowlist: string[];
  status: 'active' | 'inactive';
  last_used_at?: string | null;
  token_count: number;
}

export interface ListInternalAppsResponse {
  apps: InternalAppSummary[];
}

export interface CreateInternalAppRequest {
  name: string;
  description?: string;
  client_id: string;
  allowed_audiences: string[];
  allowed_scopes: string[];
  rate_limit_per_minute?: number;
  rate_limit_per_hour?: number;
  ip_allowlist: string[];
}

export interface UpdateInternalAppRequest {
  clientId: string;
  description?: string;
  status?: 'active' | 'inactive';
  allowed_audiences?: string[];
  allowed_scopes?: string[];
  rate_limit_per_minute?: number;
  rate_limit_per_hour?: number;
  ip_allowlist?: string[];
}

export interface InternalAppSecretResponse {
  client_id: string;
  client_secret: string;
}

export const internalAppsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listInternalApps: builder.query<ListInternalAppsResponse, void>({
      query: () => '/admin/internal-apps',
      providesTags: ['InternalApps'],
    }),

    createInternalApp: builder.mutation<InternalAppSecretResponse, CreateInternalAppRequest>({
      query: (body) => ({
        url: '/admin/internal-apps',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['InternalApps'],
    }),

    updateInternalApp: builder.mutation<{ updated: boolean }, UpdateInternalAppRequest>({
      query: ({ clientId, ...body }) => ({
        url: `/admin/internal-apps/${clientId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['InternalApps'],
    }),

    rotateInternalAppSecret: builder.mutation<InternalAppSecretResponse, { clientId: string }>({
      query: ({ clientId }) => ({
        url: `/admin/internal-apps/${clientId}:rotate-secret`,
        method: 'POST',
      }),
      invalidatesTags: ['InternalApps'],
    }),
  }),
});

export const {
  useListInternalAppsQuery,
  useCreateInternalAppMutation,
  useUpdateInternalAppMutation,
  useRotateInternalAppSecretMutation,
} = internalAppsApi;
